import { useState } from 'react'
import { QueryErrorScreen } from '@/shared/components/ui/query-error-screen'
import { CategoryFilter } from '@/shared/components/category-filter/CategoryFilter'
import { ServiceCard } from './ServiceCard'
import { usePackageCatalog } from '../hooks/usePackageCatalog'
import { ServiceCatalogSkeleton } from './ServicesSkeletons'

interface ServiceCatalogProps {
  mode: 'view' | 'select'
  /** Ids seleccionados (modo select). */
  selectedIds?: number[]
  onToggle?: (id: number) => void
  /** Ids ya contratados que se muestran deshabilitados (modo select). */
  disabledIds?: number[]
}

export function ServiceCatalog({
  mode,
  selectedIds = [],
  onToggle,
  disabledIds = [],
}: ServiceCatalogProps) {
  const { services, grouped, loading, error, refetch } = usePackageCatalog()
  const [typeLabel, setTypeLabel] = useState<string | null>(null)

  if (error && services.length === 0) {
    return <QueryErrorScreen error={error} onRetry={() => refetch()} />
  }

  if (loading) {
    return <ServiceCatalogSkeleton />
  }

  if (services.length === 0) {
    return (
      <p className="text-sm text-ink-muted">
        No hay servicios disponibles en el catálogo por el momento.
      </p>
    )
  }

  // Tipos presentes (Planes / Módulos / Servicios), en el orden de `grouped`.
  const typeLabels = grouped.map((g) => g.label)
  const visible = typeLabel
    ? services.filter((s) => s.typeLabel === typeLabel)
    : services

  return (
    <div className="space-y-4">
      <CategoryFilter categories={typeLabels} value={typeLabel} onChange={setTypeLabel} />

      {visible.length === 0 ? (
        <p className="text-sm text-ink-muted">No hay servicios en este tipo.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              mode={mode}
              selected={selectedIds.includes(service.id)}
              disabled={disabledIds.includes(service.id)}
              onToggle={() => onToggle?.(service.id)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
